import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import { cleanupAddress, clearAddressCacheAction } from 'actions/CheckoutActions/addressActions';
import { newAddressFormKey, GENERIC_ERROR, GENERIC_ERROR_MESSAGE } from 'constants/CheckoutConstants';
import get from 'lodash/get';

export const GET_MY_ADDRESSES_REQUEST = 'GET_MY_ADDRESSES_REQUEST';
export const GET_MY_ADDRESSES_SUCCESS = 'GET_MY_ADDRESSES_SUCCESS';
export const GET_MY_ADDRESSES_ERROR = 'GET_MY_ADDRESSES_ERROR';

export function getMyAddressesRequestAction() {
	return { type: GET_MY_ADDRESSES_REQUEST };
}

export function getMyAddressesSuccessAction(addresses) {
	return { type: GET_MY_ADDRESSES_SUCCESS, data: { addresses } };
}

export function getMyAddressesErrorAction(error) {
	return { type: GET_MY_ADDRESSES_ERROR, error };
}

export function fetchMyAddressesAction() {
	return dispatch => {
		dispatch(getMyAddressesRequestAction());

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/1/contacts'
			})
		).then(
			json => dispatch(getMyAddressesSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(getMyAddressesErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export const UPSERT_MY_ADDRESS_REQUEST = 'UPSERT_MY_ADDRESS_REQUEST';
export const UPSERT_MY_ADDRESS_SUCCESS = 'UPSERT_MY_ADDRESS_SUCCESS';
export const UPSERT_MY_ADDRESS_ERROR = 'UPSERT_MY_ADDRESS_ERROR';

export function upsertMyAddressRequestAction(address) {
	return { type: UPSERT_MY_ADDRESS_REQUEST, address };
}

export function upsertMyAddressErrorAction(error, addressId, addressResponse) {
	return { type: UPSERT_MY_ADDRESS_ERROR, addressId, error, addressResponse };
}

export function upsertMyAddressSuccessAction(addresses) {
	return { type: UPSERT_MY_ADDRESS_SUCCESS, addresses };
}

export const upsertAddressAction = address => {
	const settings = Object.assign({}, baseAjaxConfig, {
		pathname: '/api/3/user/contact',
		acceptErrors: true
	});
	const addressId = address.id;

	return dispatch => {
		dispatch(upsertMyAddressRequestAction(address));

		const requestBody = cleanupAddress(address);

		if (addressId !== newAddressFormKey) {
			Object.assign(requestBody, { contactId: addressId });
		}

		const apiCaller =
			addressId === newAddressFormKey ? ApiCaller.post(settings, requestBody) : ApiCaller.put(settings, requestBody);

		return apiCaller.then(
			json => {
				dispatch(clearAddressCacheAction(addressId));
				dispatch(upsertMyAddressSuccessAction(json['RESPONSE']));
			},
			err => {
				const errorCode = get(err, ['RESPONSE', 'errorCode']);
				const errorMap = {
					USER_COMMUNICATION_INVALID: 'phone',
					ADD_PINCODE_INVALID: 'pincode',
					ADD_STATE_INVALID: 'state',
					ADD_LINE1_INVALID: 'addressLine1'
				};
				const normalisedErrorCode = errorMap[errorCode] || GENERIC_ERROR;
				const errorMessage =
					get(err, 'RESPONSE.addressResponse.message') ||
					get(err, ['RESPONSE', 'errorMessage']) ||
					GENERIC_ERROR_MESSAGE;
				const error = {
					[normalisedErrorCode]: errorMessage,
					errorCode: normalisedErrorCode
				};
				const addressResponse = get(err, 'RESPONSE.addressResponse', {});
				dispatch(upsertMyAddressErrorAction(error, addressId, addressResponse));
				return Promise.reject(error);
			}
		);
	};
};

export const DELETE_ADDRESS_REQUEST = 'DELETE_ADDRESS_REQUEST';
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS';
export const DELETE_ADDRESS_ERROR = 'DELETE_ADDRESS_ERROR';

export function deleteAddressRequestAction() {
	return { type: DELETE_ADDRESS_REQUEST };
}

export function deleteAddressSuccessAction(addresses) {
	return { type: DELETE_ADDRESS_SUCCESS, data: { addresses } };
}

export function deleteAddressErrorAction(error) {
	return { type: DELETE_ADDRESS_ERROR, error };
}

export function deleteAddressAction(contactId) {
	return dispatch => {
		dispatch(deleteAddressRequestAction());

		return ApiCaller.delete(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/3/user/contact/${contactId}`
			})
		).then(
			json => dispatch(deleteAddressSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(deleteAddressErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export const MAKE_DEFAULT_ADDRESS_REQUEST = 'MAKE_DEFAULT_ADDRESS_REQUEST';
export const MAKE_DEFAULT_ADDRESS_SUCCESS = 'MAKE_DEFAULT_ADDRESS_SUCCESS';
export const MAKE_DEFAULT_ADDRESS_ERROR = 'MAKE_DEFAULT_ADDRESS_ERROR';

export function makeDefaultAddressRequestAction() {
	return { type: MAKE_DEFAULT_ADDRESS_REQUEST };
}

export function makeDefaultAddressSuccessAction(addresses) {
	return { type: MAKE_DEFAULT_ADDRESS_SUCCESS, data: { addresses } };
}

export function makeDefaultAddressErrorAction(error) {
	return { type: MAKE_DEFAULT_ADDRESS_ERROR, error };
}

export function makeDefaultAddressAction(contactId) {
	return dispatch => {
		dispatch(makeDefaultAddressRequestAction());

		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/user/contact/default'
			}),
			{
				contactId: contactId
			}
		).then(
			json => dispatch(makeDefaultAddressSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(makeDefaultAddressErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
